<form [formGroup]="form" (ngSubmit)="save()" novalidate>
  <div class="modal-header">
    <h2 class="modal-title" id="ks-field-type-modal-title">{{ title() }}</h2>

    <button type="button" class="ks-modal-close" aria-label="Cerrar" (click)="cancel()">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="ks-form-group">
      <label class="ks-label" for="ks-field-type-key">Identificador</label>

      <input
        id="ks-field-type-key"
        type="text"
        class="ks-field ks-mono"
        formControlName="fieldType"
        autocomplete="off"
        spellcheck="false"
        placeholder="username"
        [attr.aria-invalid]="invalid('fieldType') ? 'true' : null"
        [attr.aria-describedby]="invalid('fieldType') ? 'ks-field-type-key-error' : 'ks-field-type-key-hint'" />

      @if (invalid('fieldType')) {
        <p class="ks-field-error" id="ks-field-type-key-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Usa solo minúsculas, dígitos, guion y guion bajo (máx. 50).
        </p>
      } @else {
        <p class="ks-field-hint" id="ks-field-type-key-hint">
          @if (isEdit()) {
            El identificador es la llave del catálogo y no se puede cambiar.
          } @else {
            Llave del catálogo, por ejemplo <code>username</code> o <code>card_number</code>.
          }
        </p>
      }
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="ks-field-type-description">Descripción</label>

      <input
        id="ks-field-type-description"
        type="text"
        class="ks-field"
        formControlName="description"
        autocomplete="off"
        placeholder="Nombre de usuario"
        [attr.aria-invalid]="invalid('description') ? 'true' : null"
        [attr.aria-describedby]="invalid('description') ? 'ks-field-type-description-error' : null" />

      @if (invalid('description')) {
        <p class="ks-field-error" id="ks-field-type-description-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Escribe una descripción de máximo 255 caracteres.
        </p>
      }
    </div>

    <fieldset class="ks-switches">
      <legend class="ks-label">Comportamiento</legend>

      <label class="ks-switch ks-switch--row" for="ks-field-type-protected">
        <input
          id="ks-field-type-protected"
          type="checkbox"
          role="switch"
          class="ks-switch__input"
          formControlName="protected"
          aria-describedby="ks-field-type-protected-hint" />

        <span class="ks-switch__track" aria-hidden="true">
          <span class="ks-switch__thumb"></span>
        </span>

        <span class="ks-switch__text">
          <span class="ks-switch__title">Protegido</span>
          <span class="ks-switch__hint" id="ks-field-type-protected-hint">
            El valor se cifra y se muestra oculto en la app; hay que revelarlo para leerlo.
          </span>
        </span>
      </label>

      <label class="ks-switch ks-switch--row" for="ks-field-type-multiline">
        <input
          id="ks-field-type-multiline"
          type="checkbox"
          role="switch"
          class="ks-switch__input"
          formControlName="multiline"
          aria-describedby="ks-field-type-multiline-hint" />

        <span class="ks-switch__track" aria-hidden="true">
          <span class="ks-switch__thumb"></span>
        </span>

        <span class="ks-switch__text">
          <span class="ks-switch__title">Multilínea</span>
          <span class="ks-switch__hint" id="ks-field-type-multiline-hint">
            La app captura este campo en un área de texto de varios renglones.
          </span>
        </span>
      </label>

      @if (isEdit()) {
        <label class="ks-switch ks-switch--row" for="ks-field-type-status">
          <input
            id="ks-field-type-status"
            type="checkbox"
            role="switch"
            class="ks-switch__input"
            formControlName="status"
            aria-describedby="ks-field-type-status-hint" />

          <span class="ks-switch__track" aria-hidden="true">
            <span class="ks-switch__thumb"></span>
          </span>

          <span class="ks-switch__text">
            <span class="ks-switch__title">Activo</span>
            <span class="ks-switch__hint" id="ks-field-type-status-hint">
              Solo los tipos activos se pueden asignar a los campos de una plantilla.
            </span>
          </span>
        </label>
      }
    </fieldset>
  </div>

  <div class="modal-footer">
    <button type="button" class="ks-btn ks-btn--glass" (click)="cancel()">Cancelar</button>
    <button type="submit" class="ks-btn ks-btn--primary">
      <i class="bi bi-check-lg" aria-hidden="true"></i>
      Guardar
    </button>
  </div>
</form>
